import * as ng from 'angular';
import * as moment from 'moment';

ng.module('selfReg')
   .filter('momentFormat', () => momentFormatFilter);

// moment locale is set in root shell component when language changes
// filters don't normally re-run unless input value changes
// set $stateful = true to force this filter to run each digest cycle
(momentFormatFilter as ng.IFilterFunction).$stateful = true;

export function momentFormatFilter(date:any, format:string) {
   return moment(date).format(format);
}
